import { Environment } from '@chegg/commerce-utils';
var defaultConfigs = {
  ui: {
    layout: 'full',
    showSubmitButton: false,
    displayServerErrors: true,
    displayLoadingIndicator: true,
    buttonColor: undefined
  },
  withCoupon: false,
  couponCode: undefined,
  isCouponVerified: false,
  coupon: {
    addCouponStatus: '',
    removeCouponStatus: '',
    totalWithCurrencyFormat: ''
  },
  content: {
    couponContent: undefined,
    orderSummaryContent: undefined
  },
  fireRioPurchaseEvent: false,
  uvn: '',
  environment: Environment.DEVELOPMENT,
  referrer: '',
  useForter: true,
  displayOrderSummary: false,
  recurlyCart: null
};
var defaultReviewConfigs = {
  currentStep: 1,
  reviewStepEnabled: false,
  intlCountries: ['CA']
};
export { defaultConfigs, defaultReviewConfigs };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/business/configManager/constants.js
// module id = 4681
// module chunks = 11